import { ViteSSG } from 'vite-ssg';
import App from "./App.vue";
import "./assets/index.css";
import "./assets/lazyload.css";

// 使用懒加载导入路由组件 - 优化首屏加载速度
// 首页保持同步加载（首屏必需）
import Home from '@/views/Home.vue';

// 其他页面使用懒加载
const AboutUs = () => import('@/views/AboutUs.vue');
const Blog = () => import('@/views/Blog.vue');
const BlogDetail = () => import('@/views/BlogDetail.vue');
const EnergyManagement = () => import('@/views/products/EnergyManagement.vue');
const AISolutions = () => import('@/views/products/AISolutions.vue');
const IndustrialAutomation = () => import('@/views/products/IndustrialAutomation.vue');
const IntelligentInstruments = () => import('@/views/products/IntelligentInstruments.vue');
const EnterpriseSoftware = () => import('@/views/products/EnterpriseSoftware.vue');
const ChuangchengAI = () => import('@/views/DeepSeekChat.vue');

// 定义路由配置
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '创诚纪元人工智能 - 物联网+AI智能解决方案专家',
      description: '创诚纪元人工智能专注物联网+AI技术融合，提供智能能耗管理、工业自动化控制、智能仪器仪表、AI解决方案和企业级软件定制服务。'
    }
  },
  {
    path: '/about',
    name: 'AboutUs',
    component: AboutUs,
    meta: {
      title: '关于我们 - 创诚纪元人工智能',
      description: '了解创诚纪元人工智能，专业的物联网+AI解决方案提供商'
    }
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog,
    meta: {
      title: '技术博客 - 物联网AI工业自动化前沿技术 | 创诚纪元人工智能',
      description: '创诚纪元技术博客，分享物联网、人工智能、工业自动化、智慧能源领域的最新技术、实践经验和行业案例'
    }
  },
  {
    path: '/blog/:id',
    name: 'BlogDetail',
    component: BlogDetail,
    meta: {
      title: '文章详情 | 创诚纪元技术博客',
      description: '深入了解物联网、人工智能与工业自动化技术'
    }
  },
  {
    path: '/products/energy-management',
    name: 'EnergyManagement',
    component: EnergyManagement,
    meta: {
      title: '智能能耗管理 - 创诚纪元人工智能',
      description: '全方位能源监测与优化解决方案，实时监控用电、用水、碳排放数据'
    }
  },
  {
    path: '/products/ai-solutions',
    name: 'AISolutions',
    component: AISolutions,
    meta: {
      title: 'AI智能解决方案 - 创诚纪元人工智能',
      description: '人工智能技术赋能企业，提供智能分析、预测和优化解决方案'
    }
  },
  {
    path: '/products/industrial-automation',
    name: 'IndustrialAutomation',
    component: IndustrialAutomation,
    meta: {
      title: '工业自动化控制 - 创诚纪元人工智能',
      description: 'PLC编程、SCADA系统、远程监控等工业4.0自动化控制解决方案'
    }
  },
  {
    path: '/products/intelligent-instruments',
    name: 'IntelligentInstruments',
    component: IntelligentInstruments,
    meta: {
      title: '智能仪器仪表 - 创诚纪元人工智能',
      description: '高精度智能检测设备，精密测量、数据采集、无线传输'
    }
  },
  {
    path: '/products/enterprise-software',
    name: 'EnterpriseSoftware',
    component: EnterpriseSoftware,
    meta: {
      title: '企业级软件定制 - 创诚纪元人工智能',
      description: '为企业量身定制的软件解决方案，助力数字化转型'
    }
  },
  {
    path: '/chuangchengai',
    name: 'ChuangchengAI',
    component: ChuangchengAI,
    meta: {
      title: '创诚科技AI助手 - 创诚纪元人工智能',
      description: '智能对话机器人，专业技术咨询，24小时在线服务，基于深度学习的智能问答系统'
    }
  }
];

// 创建SSG应用
export const createApp = ViteSSG(
  App,
  { 
    routes,
    scrollBehavior(_to, _from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { top: 0 };
      }
    }
  },
  ({ app, router, isClient }) => {
    // 注册全局图片懒加载指令
    if (isClient) {
      import('@/directives/lazyload').then(({ lazyload }) => {
        app.directive('lazyload', lazyload);
      });
    }
    
    // 路由守卫 - 只在客户端执行
    if (isClient) {
      // 动态导入loading相关的代码，避免SSG时出错
      import('@/composables/usePageLoading').then(({ globalLoading }) => {
        router.beforeEach((to, from, next) => {
          // 设置页面标题
          if (to.meta?.title) {
            document.title = to.meta.title as string;
          }
          
          // 如果是路由切换（不是初始加载），显示loading
          if (from.name) {
            let loadingMessage = '正在加载...';
            
            if (to.meta?.title) {
              const title = (to.meta.title as string).split(' - ')[0];
              loadingMessage = `正在加载 ${title}...`;
            }
            
            globalLoading.start(loadingMessage);
          }
          
          next();
        });

        router.afterEach(() => {
          setTimeout(() => {
            globalLoading.stop();
          }, 800);
        });
      });
    }
  }
);